'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _debounce = require('lodash/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _nitroIcon = require('../nitro-icon');

var _nitroIcon2 = _interopRequireDefault(_nitroIcon);

var _styles = require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NitroSearchBar = function (_Component) {
  _inherits(NitroSearchBar, _Component);

  function NitroSearchBar(props) {
    _classCallCheck(this, NitroSearchBar);

    var _this = _possibleConstructorReturn(this, (NitroSearchBar.__proto__ || Object.getPrototypeOf(NitroSearchBar)).call(this, props));

    _this.search = function (event) {
      var searchText = event.target.value;
      _this.setState({
        searchText: searchText
      });
      _this.updateSearchText(searchText);
    };

    _this.updateSearchText = function (text) {
      _this.props.action(text);
    };

    _this.reset = function () {
      _this.setState({ searchText: '' });
      _this.props.action('');
    };

    _this.state = {
      searchText: ''
    };
    _this.updateSearchText = (0, _debounce2.default)(_this.updateSearchText, 500);
    return _this;
  }

  _createClass(NitroSearchBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          block = _props.block,
          className = _props.className,
          defaultValue = _props.defaultValue,
          disabled = _props.disabled,
          float = _props.float,
          hintText = _props.hintText,
          style = _props.style,
          textFieldHintStyle = _props.textFieldHintStyle,
          underlineShow = _props.underlineShow,
          variant = _props.variant,
          width = _props.width;


      var hintStyle = {
        left: '20px',
        right: '0',
        marginBottom: '-1px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      };

      var classes = (0, _classnames2.default)('search-bar', className);

      return _react2.default.createElement(
        _styles.SearchBar,
        {
          className: classes,
          style: style,
          block: block,
          width: width,
          float: float
        },
        _react2.default.createElement(
          _styles.SearchIcon,
          null,
          _react2.default.createElement(_nitroIcon2.default, {
            name: 'search',
            size: 12,
            variant: variant
          })
        ),
        _react2.default.createElement(_styles.Input, {
          id: 'searchInput',
          disabled: disabled,
          value: this.state.searchText,
          defaultValue: defaultValue,
          hintText: this.state.searchText ? null : hintText,
          hintStyle: textFieldHintStyle || hintStyle,
          onChange: this.search,
          fullWidth: true,
          height: '40px',
          underlineShow: underlineShow
        }),
        _react2.default.createElement(
          _styles.ClearIcon,
          { hide: this.state.searchText.length === 0 },
          _react2.default.createElement(_nitroIcon2.default, {
            name: 'close',
            size: 10,
            action: this.reset,
            variant: variant
          })
        )
      );
    }
  }]);

  return NitroSearchBar;
}(_react.Component);

NitroSearchBar.propTypes = {
  action: _propTypes2.default.func,
  block: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  defaultValue: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  float: _propTypes2.default.string,
  hintText: _propTypes2.default.string,
  style: _propTypes2.default.object,
  textFieldHintStyle: _propTypes2.default.object,
  underlineShow: _propTypes2.default.bool,
  variant: _propTypes2.default.string,
  width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
};

NitroSearchBar.defaultProps = {
  underlineShow: true
};

exports.default = NitroSearchBar;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-search-bar/NitroSearchBar.js
// module id = 3033
// module chunks = 4